import { defineMessages } from "@/i18n";
import en from "./en";

export const desktopDictationMessages = defineMessages("desktop-dictation", en);
